import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";




//User
import usersRoutes from "./administrer/users.routes"

//Configuration


//Affectation
import affectationRoutes from "./administrer/affectation.routes"

//Agent
import agentsRoutes from "./administrer/agents.routes"


//Division
import divisionRoutes from "./administrer/divisions.routes"

//Secteur
import secteurRoutes from "./administrer/secteur.routes"


//Institution
import institutionRoutes from "./administrer/institution.routes";

//Service
import serviceRoutes from "./administrer/service.routes"


//Service
import focalRoutes from "./administrer/focal.routes"



//Caracterisation
import caracterisationRoutes from "./administrer/caracterisation.routes"


//Parametres
import parametreRoutes from "./administrer/parametre.routes"

//User Profile
import profileRoutes from "./administrer/profile.routes"

//Motif
import motifRoutes from "./administrer/motif.routes"


export default {
    path: "/administrer",
    name: "Administrer",
    meta: { requiredAuth: true },
    component: AppLayoutAdmin,
    children: [
        ...profileRoutes,
        ...usersRoutes,
        ...institutionRoutes,
        ...divisionRoutes,
        ...agentsRoutes,
        ...affectationRoutes,
        ...motifRoutes,
        ...caracterisationRoutes,
        ...parametreRoutes,
        ...secteurRoutes,
        ...serviceRoutes,
        ...focalRoutes
    ]
}